import "./Destinations.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import DestinationTabs from "./sections/DestinationTabs";
import Destinations from "./sections/Destinations";
import Asiadestinationtabs from "./sections/Asiadestinationtabs";
import CaribbeanDestinations from "./sections/CaribbeanDestinations";
import Africa from "./sections/Africa";
import Footer from "@/reusable_sections/Footer";
export default function DestinationsPage() {
  return <div>
      <Header />
      <Hero />
      <DestinationTabs />
      <Africa />
      <Destinations />
      <Asiadestinationtabs />
      <CaribbeanDestinations />
      <Footer />
    </div>;
}